import * as React from 'react';
import Drawer from 'rc-drawer';
import { Button, Glyphicon } from 'react-bootstrap';

type IProps = {
    isOpen      : boolean;
    onClose     : () => void;
    title      ?: string;
    children   ?: React.ReactNode;
};

export const Sidebar: React.FC<IProps> = ( props : IProps ) => {
    return (
        <Drawer
            placement="right"
            getContainer={false}
            open={props.isOpen}
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                height: '100vh',
                width: 'max(33vw,400px)',
                zIndex: 1050
            }}
        >
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflowY: 'auto' }}>
                <div style={{ padding: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <h3 style={{ margin: 0 }}>{props.title}</h3>
                        <Button bsStyle='link' bsSize='sm' onClick={props.onClose}><Glyphicon glyph='remove' /></Button>
                    </div>
                    {props.children}
                    <div className='text-center bg-info'>
                        <Button bsStyle='link' block onClick={props.onClose}>Close This View</Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default Sidebar;
